import { render } from "./back.vue?vue&type=template&id=1b99acac&scoped=true"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"

import "./back.vue?vue&type=style&index=0&id=1b99acac&scoped=true&lang=css"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b99acac"]])

export default __exports__